import { useEffect, useRef } from 'react';
import { PIN_IDLE_REPROMPT_MS } from './pinPadLogic.js';

/** 10-03: re-prompt after 15 minutes of inactivity; does not discard the token. */
export function usePinIdleTimeout(enabled: boolean, onIdle: () => void): void {
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  useEffect(() => {
    if (!enabled) return undefined;

    let timer: number | null = null;
    const reset = () => {
      if (timer != null) window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        onIdleRef.current();
      }, PIN_IDLE_REPROMPT_MS);
    };

    const events = ['pointerdown', 'keydown', 'touchstart'] as const;
    events.forEach((event) => window.addEventListener(event, reset, { passive: true }));
    reset();

    return () => {
      if (timer != null) window.clearTimeout(timer);
      events.forEach((event) => window.removeEventListener(event, reset));
    };
  }, [enabled]);
}
